// @ts-nocheck
import './App.css'
import { AuthProvider } from './context/auth.context'
import NavigationRoutes from './navigation'

import './assets/styles/styles.scss'
import { AppProvider } from './context/app.context'
import { I18nProvider } from './context/i18n.context'

function App() {
  return (
    <AppProvider>
      <I18nProvider>
        <AuthProvider>
          <NavigationRoutes />
        </AuthProvider>
      </I18nProvider>
    </AppProvider>
  )
}

export default App
